// All tutorial videos shown across the app.
// Each page imports this same list and sets its own defaultIndex.
 
export const HELP_VIDEOS = [
  {
    title: "Create Job Smart Mode",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/Create_A_Job_Ai01.mp4",
  },
  {
    title: "Create Job Custom Mode",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/Create_A_Job_Manual01.mp4",
  },
  {
    title: "Screen A Resume",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/ScreenCV_Schedule_Interview01+(1).mp4",
  },
  {
    title: "Screen Candidates",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/Screen_Candidates01+(1).mp4",
  },
  {
    title: "Interview Management",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/Interview_Management01+(1).mp4",
  },
  {
    title: "Invite Candidates",
    url: "https://helpandsupportvideos.s3.us-east-2.amazonaws.com/Invite_Candidates01+(1).mp4",
  },
];
 